export const SET_EULA = 'EULA_SET_EULA'
export const FETCHING_EULA = 'EULA_FETCHING_EULA'



// WEBPACK FOOTER //
// ./src/features/Eula/data/eula/constants.js